export type CountryType =
  | "tr"
  | "uk"
  | "us"
  | "ng"
  | "za"
  | "au"
  | "ca"
  | "in"
  | "sg"
  | "br"
  | "ph"
  | "nz"
  | "jp"
  | "mx"
  | "kr"
  | "hk"
  | "my"
  | "id"
  | "th"
  | "vn"
  | "eu"

export type CountryOption = {
  code: CountryType
  label: string
  flag: string
}

// Priority countries shown at the top of the selector
export const priorityCountries: CountryOption[] = [
  { code: "tr", label: "Turkey", flag: "\u{1F1F9}\u{1F1F7}" },
  { code: "us", label: "United States", flag: "\u{1F1FA}\u{1F1F8}" },
  { code: "uk", label: "United Kingdom", flag: "\u{1F1EC}\u{1F1E7}" },
  { code: "eu", label: "Germany", flag: "\u{1F1E9}\u{1F1EA}" },
  { code: "ca", label: "Canada", flag: "\u{1F1E8}\u{1F1E6}" },
  { code: "au", label: "Australia", flag: "\u{1F1E6}\u{1F1FA}" }
]

// All other countries (alphabetically sorted), mapped to "eu" (IBAN) form
export const otherCountries: CountryOption[] = [
  { code: "eu", label: "Afghanistan", flag: "\u{1F1E6}\u{1F1EB}" },
  { code: "eu", label: "Albania", flag: "\u{1F1E6}\u{1F1F1}" },
  { code: "eu", label: "Algeria", flag: "\u{1F1E9}\u{1F1FF}" },
  { code: "eu", label: "Andorra", flag: "\u{1F1E6}\u{1F1E9}" },
  { code: "eu", label: "Angola", flag: "\u{1F1E6}\u{1F1F4}" },
  { code: "eu", label: "Antigua and Barbuda", flag: "\u{1F1E6}\u{1F1EC}" },
  { code: "eu", label: "Argentina", flag: "\u{1F1E6}\u{1F1F7}" },
  { code: "eu", label: "Armenia", flag: "\u{1F1E6}\u{1F1F2}" },
  { code: "eu", label: "Austria", flag: "\u{1F1E6}\u{1F1F9}" },
  { code: "eu", label: "Azerbaijan", flag: "\u{1F1E6}\u{1F1FF}" },
  { code: "eu", label: "Bahamas", flag: "\u{1F1E7}\u{1F1F8}" },
  { code: "eu", label: "Bahrain", flag: "\u{1F1E7}\u{1F1ED}" },
  { code: "eu", label: "Bangladesh", flag: "\u{1F1E7}\u{1F1E9}" },
  { code: "eu", label: "Barbados", flag: "\u{1F1E7}\u{1F1E7}" },
  { code: "eu", label: "Belarus", flag: "\u{1F1E7}\u{1F1FE}" },
  { code: "eu", label: "Belgium", flag: "\u{1F1E7}\u{1F1EA}" },
  { code: "eu", label: "Belize", flag: "\u{1F1E7}\u{1F1FF}" },
  { code: "eu", label: "Benin", flag: "\u{1F1E7}\u{1F1EF}" },
  { code: "eu", label: "Bhutan", flag: "\u{1F1E7}\u{1F1F9}" },
  { code: "eu", label: "Bolivia", flag: "\u{1F1E7}\u{1F1F4}" },
  { code: "eu", label: "Bosnia and Herzegovina", flag: "\u{1F1E7}\u{1F1E6}" },
  { code: "eu", label: "Botswana", flag: "\u{1F1E7}\u{1F1FC}" },
  { code: "br", label: "Brazil", flag: "\u{1F1E7}\u{1F1F7}" },
  { code: "eu", label: "Brunei", flag: "\u{1F1E7}\u{1F1F3}" },
  { code: "eu", label: "Bulgaria", flag: "\u{1F1E7}\u{1F1EC}" },
  { code: "eu", label: "Burkina Faso", flag: "\u{1F1E7}\u{1F1EB}" },
  { code: "eu", label: "Burundi", flag: "\u{1F1E7}\u{1F1EE}" },
  { code: "eu", label: "Cabo Verde", flag: "\u{1F1E8}\u{1F1FB}" },
  { code: "eu", label: "Cambodia", flag: "\u{1F1F0}\u{1F1ED}" },
  { code: "eu", label: "Cameroon", flag: "\u{1F1E8}\u{1F1F2}" },
  { code: "eu", label: "Central African Republic", flag: "\u{1F1E8}\u{1F1EB}" },
  { code: "eu", label: "Chad", flag: "\u{1F1F9}\u{1F1E9}" },
  { code: "eu", label: "Chile", flag: "\u{1F1E8}\u{1F1F1}" },
  { code: "eu", label: "China", flag: "\u{1F1E8}\u{1F1F3}" },
  { code: "eu", label: "Colombia", flag: "\u{1F1E8}\u{1F1F4}" },
  { code: "eu", label: "Comoros", flag: "\u{1F1F0}\u{1F1F2}" },
  { code: "eu", label: "Congo", flag: "\u{1F1E8}\u{1F1EC}" },
  { code: "eu", label: "Costa Rica", flag: "\u{1F1E8}\u{1F1F7}" },
  { code: "eu", label: "Croatia", flag: "\u{1F1ED}\u{1F1F7}" },
  { code: "eu", label: "Cuba", flag: "\u{1F1E8}\u{1F1FA}" },
  { code: "eu", label: "Cyprus", flag: "\u{1F1E8}\u{1F1FE}" },
  { code: "eu", label: "Czech Republic", flag: "\u{1F1E8}\u{1F1FF}" },
  { code: "eu", label: "Denmark", flag: "\u{1F1E9}\u{1F1F0}" },
  { code: "eu", label: "Djibouti", flag: "\u{1F1E9}\u{1F1EF}" },
  { code: "eu", label: "Dominica", flag: "\u{1F1E9}\u{1F1F2}" },
  { code: "eu", label: "Dominican Republic", flag: "\u{1F1E9}\u{1F1F4}" },
  { code: "eu", label: "East Timor (Timor-Leste)", flag: "\u{1F1F9}\u{1F1F1}" },
  { code: "eu", label: "Ecuador", flag: "\u{1F1EA}\u{1F1E8}" },
  { code: "eu", label: "Egypt", flag: "\u{1F1EA}\u{1F1EC}" },
  { code: "eu", label: "El Salvador", flag: "\u{1F1F8}\u{1F1FB}" },
  { code: "eu", label: "Equatorial Guinea", flag: "\u{1F1EC}\u{1F1F6}" },
  { code: "eu", label: "Eritrea", flag: "\u{1F1EA}\u{1F1F7}" },
  { code: "eu", label: "Estonia", flag: "\u{1F1EA}\u{1F1EA}" },
  { code: "eu", label: "Eswatini", flag: "\u{1F1F8}\u{1F1FF}" },
  { code: "eu", label: "Ethiopia", flag: "\u{1F1EA}\u{1F1F9}" },
  { code: "eu", label: "Fiji", flag: "\u{1F1EB}\u{1F1EF}" },
  { code: "eu", label: "Finland", flag: "\u{1F1EB}\u{1F1EE}" },
  { code: "eu", label: "France", flag: "\u{1F1EB}\u{1F1F7}" },
  { code: "eu", label: "Gabon", flag: "\u{1F1EC}\u{1F1E6}" },
  { code: "eu", label: "Gambia", flag: "\u{1F1EC}\u{1F1F2}" },
  { code: "eu", label: "Georgia", flag: "\u{1F1EC}\u{1F1EA}" },
  { code: "eu", label: "Ghana", flag: "\u{1F1EC}\u{1F1ED}" },
  { code: "eu", label: "Greece", flag: "\u{1F1EC}\u{1F1F7}" },
  { code: "eu", label: "Grenada", flag: "\u{1F1EC}\u{1F1E9}" },
  { code: "eu", label: "Guatemala", flag: "\u{1F1EC}\u{1F1F9}" },
  { code: "eu", label: "Guinea", flag: "\u{1F1EC}\u{1F1F3}" },
  { code: "eu", label: "Guinea-Bissau", flag: "\u{1F1EC}\u{1F1FC}" },
  { code: "eu", label: "Guyana", flag: "\u{1F1EC}\u{1F1FE}" },
  { code: "eu", label: "Haiti", flag: "\u{1F1ED}\u{1F1F9}" },
  { code: "eu", label: "Honduras", flag: "\u{1F1ED}\u{1F1F3}" },
  { code: "hk", label: "Hong Kong", flag: "\u{1F1ED}\u{1F1F0}" },
  { code: "eu", label: "Hungary", flag: "\u{1F1ED}\u{1F1FA}" },
  { code: "eu", label: "Iceland", flag: "\u{1F1EE}\u{1F1F8}" },
  { code: "in", label: "India", flag: "\u{1F1EE}\u{1F1F3}" },
  { code: "id", label: "Indonesia", flag: "\u{1F1EE}\u{1F1E9}" },
  { code: "eu", label: "Iran", flag: "\u{1F1EE}\u{1F1F7}" },
  { code: "eu", label: "Iraq", flag: "\u{1F1EE}\u{1F1F6}" },
  { code: "eu", label: "Ireland", flag: "\u{1F1EE}\u{1F1EA}" },
  { code: "eu", label: "Israel", flag: "\u{1F1EE}\u{1F1F1}" },
  { code: "eu", label: "Italy", flag: "\u{1F1EE}\u{1F1F9}" },
  { code: "eu", label: "Ivory Coast", flag: "\u{1F1E8}\u{1F1EE}" },
  { code: "eu", label: "Jamaica", flag: "\u{1F1EF}\u{1F1F2}" },
  { code: "jp", label: "Japan", flag: "\u{1F1EF}\u{1F1F5}" },
  { code: "eu", label: "Jordan", flag: "\u{1F1EF}\u{1F1F4}" },
  { code: "eu", label: "Kazakhstan", flag: "\u{1F1F0}\u{1F1FF}" },
  { code: "eu", label: "Kenya", flag: "\u{1F1F0}\u{1F1EA}" },
  { code: "eu", label: "Kiribati", flag: "\u{1F1F0}\u{1F1EE}" },
  { code: "eu", label: "Korea, North", flag: "\u{1F1F0}\u{1F1F5}" },
  { code: "eu", label: "Korea, South", flag: "\u{1F1F0}\u{1F1F7}" },
  { code: "eu", label: "Kosovo", flag: "\u{1F1FD}\u{1F1F0}" },
  { code: "eu", label: "Kuwait", flag: "\u{1F1F0}\u{1F1FC}" },
  { code: "eu", label: "Kyrgyzstan", flag: "\u{1F1F0}\u{1F1EC}" },
  { code: "eu", label: "Laos", flag: "\u{1F1F1}\u{1F1E6}" },
  { code: "eu", label: "Latvia", flag: "\u{1F1F1}\u{1F1FB}" },
  { code: "eu", label: "Lebanon", flag: "\u{1F1F1}\u{1F1E7}" },
  { code: "eu", label: "Lesotho", flag: "\u{1F1F1}\u{1F1F8}" },
  { code: "eu", label: "Liberia", flag: "\u{1F1F1}\u{1F1F7}" },
  { code: "eu", label: "Libya", flag: "\u{1F1F1}\u{1F1FE}" },
  { code: "eu", label: "Liechtenstein", flag: "\u{1F1F1}\u{1F1EE}" },
  { code: "eu", label: "Lithuania", flag: "\u{1F1F1}\u{1F1F9}" },
  { code: "eu", label: "Luxembourg", flag: "\u{1F1F1}\u{1F1FA}" },
  { code: "eu", label: "Madagascar", flag: "\u{1F1F2}\u{1F1EC}" },
  { code: "eu", label: "Malawi", flag: "\u{1F1F2}\u{1F1FC}" },
  { code: "my", label: "Malaysia", flag: "\u{1F1F2}\u{1F1FE}" },
  { code: "eu", label: "Maldives", flag: "\u{1F1F2}\u{1F1FB}" },
  { code: "eu", label: "Mali", flag: "\u{1F1F2}\u{1F1F1}" },
  { code: "eu", label: "Malta", flag: "\u{1F1F2}\u{1F1F9}" },
  { code: "eu", label: "Marshall Islands", flag: "\u{1F1F2}\u{1F1ED}" },
  { code: "eu", label: "Mauritania", flag: "\u{1F1F2}\u{1F1F7}" },
  { code: "eu", label: "Mauritius", flag: "\u{1F1F2}\u{1F1FA}" },
  { code: "mx", label: "Mexico", flag: "\u{1F1F2}\u{1F1FD}" },
  { code: "eu", label: "Micronesia", flag: "\u{1F1EB}\u{1F1F2}" },
  { code: "eu", label: "Moldova", flag: "\u{1F1F2}\u{1F1E9}" },
  { code: "eu", label: "Monaco", flag: "\u{1F1F2}\u{1F1E8}" },
  { code: "eu", label: "Mongolia", flag: "\u{1F1F2}\u{1F1F3}" },
  { code: "eu", label: "Montenegro", flag: "\u{1F1F2}\u{1F1EA}" },
  { code: "eu", label: "Morocco", flag: "\u{1F1F2}\u{1F1E6}" },
  { code: "eu", label: "Mozambique", flag: "\u{1F1F2}\u{1F1FF}" },
  { code: "eu", label: "Myanmar (Burma)", flag: "\u{1F1F2}\u{1F1F2}" },
  { code: "eu", label: "Namibia", flag: "\u{1F1F3}\u{1F1E6}" },
  { code: "eu", label: "Nauru", flag: "\u{1F1F3}\u{1F1F7}" },
  { code: "eu", label: "Nepal", flag: "\u{1F1F3}\u{1F1F5}" },
  { code: "eu", label: "Netherlands", flag: "\u{1F1F3}\u{1F1F1}" },
  { code: "nz", label: "New Zealand", flag: "\u{1F1F3}\u{1F1FF}" },
  { code: "eu", label: "Nicaragua", flag: "\u{1F1F3}\u{1F1EE}" },
  { code: "eu", label: "Niger", flag: "\u{1F1F3}\u{1F1EA}" },
  { code: "ng", label: "Nigeria", flag: "\u{1F1F3}\u{1F1EC}" },
  { code: "eu", label: "North Macedonia", flag: "\u{1F1F2}\u{1F1F0}" },
  { code: "eu", label: "Norway", flag: "\u{1F1F3}\u{1F1F4}" },
  { code: "eu", label: "Oman", flag: "\u{1F1F4}\u{1F1F2}" },
  { code: "eu", label: "Pakistan", flag: "\u{1F1F5}\u{1F1F0}" },
  { code: "eu", label: "Palau", flag: "\u{1F1F5}\u{1F1FC}" },
  { code: "eu", label: "Panama", flag: "\u{1F1F5}\u{1F1E6}" },
  { code: "eu", label: "Papua New Guinea", flag: "\u{1F1F5}\u{1F1EC}" },
  { code: "eu", label: "Paraguay", flag: "\u{1F1F5}\u{1F1FE}" },
  { code: "eu", label: "Peru", flag: "\u{1F1F5}\u{1F1EA}" },
  { code: "ph", label: "Philippines", flag: "\u{1F1F5}\u{1F1ED}" },
  { code: "eu", label: "Poland", flag: "\u{1F1F5}\u{1F1F1}" },
  { code: "eu", label: "Portugal", flag: "\u{1F1F5}\u{1F1F9}" },
  { code: "eu", label: "Qatar", flag: "\u{1F1F6}\u{1F1E6}" },
  { code: "eu", label: "Romania", flag: "\u{1F1F7}\u{1F1F4}" },
  { code: "eu", label: "Russia", flag: "\u{1F1F7}\u{1F1FA}" },
  { code: "eu", label: "Rwanda", flag: "\u{1F1F7}\u{1F1FC}" },
  { code: "eu", label: "Saint Kitts and Nevis", flag: "\u{1F1F0}\u{1F1F3}" },
  { code: "eu", label: "Saint Lucia", flag: "\u{1F1F1}\u{1F1E8}" },
  { code: "eu", label: "Saint Vincent and the Grenadines", flag: "\u{1F1FB}\u{1F1E8}" },
  { code: "eu", label: "Samoa", flag: "\u{1F1FC}\u{1F1F8}" },
  { code: "eu", label: "San Marino", flag: "\u{1F1F8}\u{1F1F2}" },
  { code: "eu", label: "Sao Tome and Principe", flag: "\u{1F1F8}\u{1F1F9}" },
  { code: "eu", label: "Saudi Arabia", flag: "\u{1F1F8}\u{1F1E6}" },
  { code: "eu", label: "Senegal", flag: "\u{1F1F8}\u{1F1F3}" },
  { code: "eu", label: "Serbia", flag: "\u{1F1F7}\u{1F1F8}" },
  { code: "eu", label: "Seychelles", flag: "\u{1F1F8}\u{1F1E8}" },
  { code: "eu", label: "Sierra Leone", flag: "\u{1F1F8}\u{1F1F1}" },
  { code: "sg", label: "Singapore", flag: "\u{1F1F8}\u{1F1EC}" },
  { code: "eu", label: "Slovakia", flag: "\u{1F1F8}\u{1F1F0}" },
  { code: "eu", label: "Slovenia", flag: "\u{1F1F8}\u{1F1EE}" },
  { code: "eu", label: "Solomon Islands", flag: "\u{1F1F8}\u{1F1E7}" },
  { code: "eu", label: "Somalia", flag: "\u{1F1F8}\u{1F1F4}" },
  { code: "za", label: "South Africa", flag: "\u{1F1FF}\u{1F1E6}" },
  { code: "kr", label: "South Korea", flag: "\u{1F1F0}\u{1F1F7}" },
  { code: "eu", label: "South Sudan", flag: "\u{1F1F8}\u{1F1F8}" },
  { code: "eu", label: "Spain", flag: "\u{1F1EA}\u{1F1F8}" },
  { code: "eu", label: "Sri Lanka", flag: "\u{1F1F1}\u{1F1F0}" },
  { code: "eu", label: "Sudan", flag: "\u{1F1F8}\u{1F1E9}" },
  { code: "eu", label: "Suriname", flag: "\u{1F1F8}\u{1F1F7}" },
  { code: "eu", label: "Sweden", flag: "\u{1F1F8}\u{1F1EA}" },
  { code: "eu", label: "Switzerland", flag: "\u{1F1E8}\u{1F1ED}" },
  { code: "eu", label: "Syria", flag: "\u{1F1F8}\u{1F1FE}" },
  { code: "eu", label: "Taiwan", flag: "\u{1F1F9}\u{1F1FC}" },
  { code: "eu", label: "Tajikistan", flag: "\u{1F1F9}\u{1F1EF}" },
  { code: "eu", label: "Tanzania", flag: "\u{1F1F9}\u{1F1FF}" },
  { code: "th", label: "Thailand", flag: "\u{1F1F9}\u{1F1ED}" },
  { code: "eu", label: "Togo", flag: "\u{1F1F9}\u{1F1EC}" },
  { code: "eu", label: "Tonga", flag: "\u{1F1F9}\u{1F1F4}" },
  { code: "eu", label: "Trinidad and Tobago", flag: "\u{1F1F9}\u{1F1F9}" },
  { code: "eu", label: "Tunisia", flag: "\u{1F1F9}\u{1F1F3}" },
  { code: "eu", label: "Turkmenistan", flag: "\u{1F1F9}\u{1F1F2}" },
  { code: "eu", label: "Tuvalu", flag: "\u{1F1F9}\u{1F1FB}" },
  { code: "eu", label: "Uganda", flag: "\u{1F1FA}\u{1F1EC}" },
  { code: "eu", label: "Ukraine", flag: "\u{1F1FA}\u{1F1E6}" },
  { code: "eu", label: "United Arab Emirates", flag: "\u{1F1E6}\u{1F1EA}" },
  { code: "eu", label: "Uruguay", flag: "\u{1F1FA}\u{1F1FE}" },
  { code: "eu", label: "Uzbekistan", flag: "\u{1F1FA}\u{1F1FF}" },
  { code: "eu", label: "Vanuatu", flag: "\u{1F1FB}\u{1F1FA}" },
  { code: "eu", label: "Vatican City", flag: "\u{1F1FB}\u{1F1E6}" },
  { code: "eu", label: "Venezuela", flag: "\u{1F1FB}\u{1F1EA}" },
  { code: "vn", label: "Vietnam", flag: "\u{1F1FB}\u{1F1F3}" },
  { code: "eu", label: "Yemen", flag: "\u{1F1FE}\u{1F1EA}" },
  { code: "eu", label: "Zambia", flag: "\u{1F1FF}\u{1F1F2}" },
  { code: "eu", label: "Zimbabwe", flag: "\u{1F1FF}\u{1F1FC}" }
]

// Combined list: priority first, then others alphabetically
export const allCountries: CountryOption[] = [...priorityCountries, ...otherCountries]

// Legacy export for backward compatibility
export const countryOptions = priorityCountries

const countryMap: Record<string, CountryType> = {
  turkey: "tr",
  tr: "tr",
  "united kingdom": "uk",
  uk: "uk",
  "united states": "us",
  "united states of america": "us",
  us: "us",
  usa: "us",
  nigeria: "ng",
  ng: "ng",
  "south africa": "za",
  za: "za",
  australia: "au",
  au: "au",
  canada: "ca",
  ca: "ca",
  india: "in",
  in: "in",
  singapore: "sg",
  sg: "sg",
  brazil: "br",
  br: "br",
  philippines: "ph",
  ph: "ph",
  "new zealand": "nz",
  nz: "nz",
  japan: "jp",
  jp: "jp",
  mexico: "mx",
  mx: "mx",
  "south korea": "kr",
  korea: "kr",
  kr: "kr",
  "hong kong": "hk",
  hk: "hk",
  malaysia: "my",
  my: "my",
  indonesia: "id",
  id: "id",
  thailand: "th",
  th: "th",
  vietnam: "vn",
  vn: "vn"
}

export const resolveCountryType = (countryLabel?: string): CountryType => {
  if (!countryLabel) return "eu"
  const key = countryLabel.toLowerCase().trim()
  return countryMap[key] || "eu"
}

export const nigeriaBankOptions = [
  { label: "Access Bank", value: 1, value2: "Access Bank", bankCode: "044" },
  { label: "Citibank Nigeria", value: 2, value2: "Citibank Nigeria", bankCode: "023" },
  { label: "Ecobank Nigeria", value: 3, value2: "Ecobank Nigeria", bankCode: "050" },
  { label: "Fidelity Bank", value: 4, value2: "Fidelity Bank", bankCode: "070" },
  { label: "First Bank of Nigeria", value: 5, value2: "First Bank of Nigeria", bankCode: "011" },
  { label: "First City Monument Bank (FCMB)", value: 6, value2: "First City Monument Bank", bankCode: "214" },
  { label: "Guaranty Trust Bank (GTBank)", value: 7, value2: "Guaranty Trust Bank", bankCode: "058" },
  { label: "Heritage Bank", value: 8, value2: "Heritage Bank", bankCode: "030" },
  { label: "Keystone Bank", value: 9, value2: "Keystone Bank", bankCode: "082" },
  { label: "Polaris Bank", value: 10, value2: "Polaris Bank", bankCode: "076" },
  { label: "Stanbic IBTC Bank", value: 11, value2: "Stanbic IBTC Bank", bankCode: "221" },
  { label: "Standard Chartered Bank", value: 12, value2: "Standard Chartered Bank", bankCode: "068" },
  { label: "Sterling Bank", value: 13, value2: "Sterling Bank", bankCode: "232" },
  { label: "Union Bank of Nigeria", value: 14, value2: "Union Bank of Nigeria", bankCode: "032" },
  { label: "United Bank for Africa (UBA)", value: 15, value2: "United Bank for Africa", bankCode: "033" },
  { label: "Unity Bank", value: 16, value2: "Unity Bank", bankCode: "215" },
  { label: "Wema Bank", value: 17, value2: "Wema Bank", bankCode: "035" },
  { label: "Zenith Bank", value: 18, value2: "Zenith Bank", bankCode: "057" }
]

export const southAfricaBankOptions = [
  { label: "ABSA Bank", value: 1, value2: "ABSA Bank" },
  { label: "African Bank", value: 2, value2: "African Bank" },
  { label: "Bidvest Bank", value: 3, value2: "Bidvest Bank" },
  { label: "Capitec Bank", value: 4, value2: "Capitec Bank" },
  { label: "Discovery Bank", value: 5, value2: "Discovery Bank" },
  { label: "First National Bank (FNB)", value: 6, value2: "First National Bank" },
  { label: "Investec Bank", value: 7, value2: "Investec Bank" },
  { label: "Nedbank", value: 8, value2: "Nedbank" },
  { label: "Standard Bank", value: 9, value2: "Standard Bank" },
  { label: "TymeBank", value: 10, value2: "TymeBank" }
]

export const saAccountTypeOptions = [
  { label: "Cheque", value: 1, value2: "Cheque" },
  { label: "Savings", value: 2, value2: "Savings" }
]

export const brazilAccountTypeOptions = [
  { label: "Checking", value: 1, value2: "Checking" },
  { label: "Savings", value: 2, value2: "Savings" }
]

export const philippinesBankOptions = [
  { label: "BDO Unibank", value: 1, value2: "BDO Unibank" },
  { label: "Bank of the Philippine Islands (BPI)", value: 2, value2: "Bank of the Philippine Islands" },
  { label: "Metrobank", value: 3, value2: "Metrobank" },
  { label: "Land Bank of the Philippines", value: 4, value2: "Land Bank of the Philippines" },
  { label: "Philippine National Bank (PNB)", value: 5, value2: "Philippine National Bank" },
  { label: "China Banking Corporation", value: 6, value2: "China Banking Corporation" },
  { label: "Security Bank", value: 7, value2: "Security Bank" },
  { label: "UnionBank of the Philippines", value: 8, value2: "UnionBank of the Philippines" },
  { label: "RCBC", value: 9, value2: "RCBC" },
  { label: "EastWest Bank", value: 10, value2: "EastWest Bank" },
  { label: "GCash / GXI", value: 11, value2: "GCash" },
  { label: "Maya (PayMaya)", value: 12, value2: "Maya" }
]

export const newZealandBankPrefixes: Record<string, string> = {
  "01": "ANZ Bank New Zealand",
  "02": "Bank of New Zealand (BNZ)",
  "03": "Westpac New Zealand",
  "06": "ANZ Bank New Zealand",
  "08": "Bank of New Zealand (BNZ)",
  "09": "Reserve Bank of New Zealand",
  11: "ASB Bank",
  12: "ASB Bank",
  15: "TSB Bank",
  20: "HSBC New Zealand",
  25: "HSBC New Zealand",
  30: "Westpac New Zealand",
  31: "Heartland Bank",
  33: "SBS Bank",
  35: "The Co-operative Bank",
  38: "Kiwibank"
}

export const resolveNZBankName = (accountNumber?: string): string => {
  const cleaned = (accountNumber || "").replace(/\D/g, "")
  if (cleaned.length < 2) return ""
  return newZealandBankPrefixes[cleaned.slice(0, 2)] || ""
}

// Japan's three account types, under the names the bank prints and the numbers its network routes on.
// The name is what gets stored, so the panel and the export stay readable; the number is here for a
// payout that asks for it instead.
export const japanAccountTypeOptions = [
  { label: "Ordinary (Futsuu)", value: 1, value2: "Ordinary", zenginCode: "1" },
  { label: "Current (Toza)", value: 2, value2: "Current", zenginCode: "2" },
  { label: "Savings (Chochiku)", value: 4, value2: "Savings", zenginCode: "4" }
]

// Japan writes an account holder's name in English or in Katakana and nothing else: Kanji and Hiragana
// are rejected by the receiving bank rather than transliterated. Full width and half width Katakana
// both count, along with the punctuation a name is written with.
const JAPANESE_NAME_PATTERN = /^[A-Za-z0-9゠-ヿｦ-ﾟｰ\s.,'()\-・･/]+$/

export const isJapaneseAccountHolderName = (name?: string): boolean =>
  JAPANESE_NAME_PATTERN.test((name || "").trim())

/**
 * Mexico's eighteenth CLABE digit, checked against the seventeen in front of it.
 *
 * Run before the form submits, because a CLABE is eighteen digits of nothing but digits and there is
 * nothing else in it to notice a mistyped one by. The check digit is the only thing that tells a real
 * account apart from a number that is merely the right length.
 */
export const isClabeValid = (clabe?: string): boolean => {
  const digits = (clabe || "").replace(/\D/g, "")
  if (digits.length !== 18) return false

  const weights = [3, 7, 1]
  let total = 0
  for (let index = 0; index < 17; index += 1) {
    total += (parseInt(digits[index], 10) * weights[index % 3]) % 10
  }

  return (10 - (total % 10)) % 10 === parseInt(digits[17], 10)
}
